import { useState, useEffect } from "react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom"; 

const navLinks = [
  {
    title: "About Author",
    path: "/about",
  },
  {
    title: "⁠The Book",
    path: "/the-book",
  },
  {
    title: "The Film",
    path: "/the-film",
  },
  {
    title: "⁠Awards",
    path: "/awards",
  },
  {
    title: "Fun/Trivia",
    path: "/fun-trivia",
  },
  {
    title: "Contact",
    path: "/contact",
  }
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "auto";
  }, [mobileOpen]);

  return (
    <header className="header_wrapper_ border-b border-gray-300 sticky top-0 z-50">
      <div className="relative z-50 page-width">
      <div className="flex items-center justify-between py-3">
        {/* Mobile menu toggle */}
        <button className="md:hidden" onClick={() => setMobileOpen(true)} aria-label="Open menu">
          <Bars3Icon className="w-6 h-6" />
        </button>

        {/* Logo */}
        <div className="flex-1 text-center md:text-left">
          <Link to="/">
            <img src="/Images/logo.png" alt="Ghosted MD logo" width="570" height="59" className="h-10 mx-auto md:mx-0 logo__" />
          </Link>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-6">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="text-white font-medium main_item_nav"
            >
              {link.title}
            </Link>
          ))}
        </nav>
      </div>

      {/* Backdrop */}
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-40"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* Mobile Drawer */}
      <div
        className={`fixed top-0 left-0 w-72 h-full header_drawer_ z-50 shadow-md transition-transform duration-300 ease-in-out transform ${
          mobileOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
          <Link to="/" onClick={() => setMobileOpen(false)}>
            <img src="/Images/logo.png" alt="Ghosted MD logo" width="570" height="59" className="drawerLogo" />
          </Link>
          <button onClick={() => setMobileOpen(false)} aria-label="Close menu">
            <XMarkIcon className="w-6 h-6 text-white" />
          </button>
        </div>

        <div className="px-4 pt-4 pb-6">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="block py-2 text-white"
              onClick={() => setMobileOpen(false)}
            >
              {link.title}
            </Link>
          ))}
        </div>
      </div>
      </div>
    </header>
  );
};

export default Header;
